import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const dashboardAPI = {
  getOverview: () => axios.get(`${API}/dashboard/overview`, { headers: getAuthHeaders() }),
};

export const salesAPI = {
  getAnalytics: () => axios.get(`${API}/sales/analytics`, { headers: getAuthHeaders() }),
  generateRecommendations: () => axios.post(`${API}/sales/recommendations`, {}, { headers: getAuthHeaders() }),
  getRecommendations: () => axios.get(`${API}/sales/recommendations`, { headers: getAuthHeaders() }),
  getSales: () => axios.get(`${API}/sales`, { headers: getAuthHeaders() }),
  createSale: (data) => axios.post(`${API}/sales`, data, { headers: getAuthHeaders() }),
};

export const subscriptionAPI = {
  calculatePrice: (data) => axios.post(`${API}/subscription/calculate-price`, data, { headers: getAuthHeaders() }),
  getRequests: () => axios.get(`${API}/subscription/requests`, { headers: getAuthHeaders() }),
  getAnalytics: () => axios.get(`${API}/subscription/analytics`, { headers: getAuthHeaders() }),
  updateStatus: (id, status) => axios.patch(`${API}/subscription/requests/${id}/status?status=${status}`, {}, { headers: getAuthHeaders() }),
};

export const projectAPI = {
  getProjects: () => axios.get(`${API}/projects`, { headers: getAuthHeaders() }),
  createProject: (data) => axios.post(`${API}/projects`, data, { headers: getAuthHeaders() }),
};

export const agencyAPI = {
  getAgencies: () => axios.get(`${API}/agencies`, { headers: getAuthHeaders() }),
  createAgency: (data) => axios.post(`${API}/agencies`, data, { headers: getAuthHeaders() }),
  getAgents: () => axios.get(`${API}/agents`, { headers: getAuthHeaders() }),
  createAgent: (data) => axios.post(`${API}/agents`, data, { headers: getAuthHeaders() }),
};